// extracted by mini-css-extract-plugin
module.exports = {"container":"intro_container__USDes","paragraph":"intro_paragraph__R5sfe","button":"intro_button__WNyEx","externalIconSvg":"intro_externalIconSvg__kx2H3"};